module.exports = __webpack_public_path__ + "img/logo-icon.ff8d783d.svg";